import React from 'react';
import { useRoutes, useLocation } from 'react-router-dom';
import Login from '../../routes/login';
import Expired from '../../routes/expired';
import SpecialRoute from '../../components/misc/SpecialRoute';
import ProtectedRoute from '../../components/misc/ProtectedRoute';
import NotFound from '../../routes/notFound';
import Home from '../../routes/home';
import ChangePassword from '../../features/authentication/components/ChangePassword';
import ResetPassword from '../../features/authentication/components/ResetPassword';
import Settings from '../../routes/settings';

import Container from '../Container';
import AuthSSO from '../../routes/authSSO';
import File from '../../routes/file';

const Layout = () => {
	const element = useRoutes([
		{
			path: '/login',
			element: (
				<SpecialRoute>
					<Login />
				</SpecialRoute>
			),
		},
		{
			path: '/expired',
			element: (
				<ProtectedRoute>
					<Expired />
				</ProtectedRoute>
			),
		},
		{
			path: '/',
			element: (
				<ProtectedRoute>
					<Home currentTab={'activities'} />
				</ProtectedRoute>
			),
		},
		{
			path: '/activities',
			element: (
				<ProtectedRoute>
					<Home currentTab={'activities'} />
				</ProtectedRoute>
			),
		},
		{
			path: '/planning',
			element: (
				<ProtectedRoute>
					<Home currentTab={'planning'} />
				</ProtectedRoute>
			),
		},
		{
			path: '/settings',
			element: (
				<ProtectedRoute>
					<Settings />
				</ProtectedRoute>
			),
		},
		{
			path: '/change-password',
			element: (
				<ProtectedRoute>
					<ChangePassword />
				</ProtectedRoute>
			),
		},
		{
			path: '/reset-password',
			element: (
				<SpecialRoute>
					<ResetPassword />
				</SpecialRoute>
			),
		},
		{
			path: '/set-password',
			element: (
				<SpecialRoute>
					<ResetPassword />
				</SpecialRoute>
			),
		},
		{
			path: '/file/:id',
			element: (
				<ProtectedRoute>
					<File />
				</ProtectedRoute>
			),
		},
		{
			path: '*',
			element: <NotFound />,
		},
		{
			exact: true,
			path: '/login/auth_sso',
			element: <AuthSSO />,
		},
	]);

	const location = useLocation();

	return (
		<Container>
			{React.cloneElement(element, { key: location.pathname })}
		</Container>
	);
};

export default Layout;
